"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUploadsInProgress = exports.accumulateStateFromNodes = exports.nodesRecursiveForEach = void 0;
function nodesRecursiveForEach(nodes, callback) {
    nodes.forEach((node) => {
        callback(node);
        if (node.children != null) {
            nodesRecursiveForEach(node.children, callback);
        }
    });
}
exports.nodesRecursiveForEach = nodesRecursiveForEach;
function accumulateStateFromNodes(nodes) {
    const linkState = { links: [], pictures: [] };
    nodesRecursiveForEach(nodes, (n) => {
        if ((n.type === 'link' || n.type === 'image' || n.type === 'expanded_link') && n.url != null) {
            linkState.links.push(n.url);
        }
        if (n.type === 'image' && n.url != null) {
            linkState.pictures.push(n.url);
        }
    });
    return linkState;
}
exports.accumulateStateFromNodes = accumulateStateFromNodes;
function hasUploadsInProgress(nodes) {
    for (const node of nodes) {
        if (node.type === 'upload_in_progress') {
            return true;
        }
    }
    return false;
}
exports.hasUploadsInProgress = hasUploadsInProgress;
//# sourceMappingURL=accumulateStateFromNodes.js.map